// 页脚。除基座原有的版权署名外，追加**商业化对外必需**的两项（本项目自有）：
//   1. ICP 备案号 —— 备案要求必须在网站底部展示，并链接到工信部查询系统；
//   2. 用户协议 / 隐私政策入口 —— 支付宝签约审核会实际访问。
// 三项均由管理员在「设置 → 运营内容 → 合规内容」配置，未配置则不显示（不留空壳链接）。
import { Link, Container, Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const siteInfo = useSelector((state) => state.siteInfo);
  const icp = siteInfo.icp_record_number;
  const hasLegal = siteInfo.user_agreement_enabled || siteInfo.privacy_policy_enabled || siteInfo.refund_policy_enabled;

  return (
    <Container sx={{ py: 2 }}>
      <Stack spacing={0.8} alignItems="center" sx={{ textAlign: 'center' }}>
        {/* 版权署名（MIT 要求保留） */}
        <Box>
          {siteInfo.footer_html ? (
            <div className="custom-footer" dangerouslySetInnerHTML={{ __html: siteInfo.footer_html }}></div>
          ) : (
            <Typography variant="body2" component="div">
              <Link href="https://github.com/songquanpeng/one-api" target="_blank">
                {siteInfo.system_name} {process.env.REACT_APP_VERSION}{' '}
              </Link>
              由{' '}
              <Link href="https://github.com/songquanpeng" target="_blank">
                JustSong
              </Link>{' '}
              构建，主题 berry 来自{' '}
              <Link href="https://github.com/MartialBE" target="_blank">
                MartialBE
              </Link>{' '}
              ，源代码遵循
              <Link href="https://opensource.org/licenses/mit-license.php"> MIT 协议</Link>
            </Typography>
          )}
        </Box>

        {/* 合规入口：仅在管理员配置了内容后才显示 */}
        {hasLegal && (
          <Stack direction="row" spacing={1.5} justifyContent="center">
            {siteInfo.user_agreement_enabled && (
              <Link component={RouterLink} to="/user-agreement" variant="body2" color="text.secondary">
                用户协议
              </Link>
            )}
            {siteInfo.privacy_policy_enabled && (
              <Link component={RouterLink} to="/privacy-policy" variant="body2" color="text.secondary">
                隐私政策
              </Link>
            )}
            {siteInfo.refund_policy_enabled && (
              <Link component={RouterLink} to="/refund-policy" variant="body2" color="text.secondary">
                退款政策
              </Link>
            )}
          </Stack>
        )}

        {/* ICP 备案号：备案要求展示并链到工信部查询系统 */}
        {icp && (
          <Link
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
            variant="body2"
            color="text.secondary"
            underline="hover"
          >
            {icp}
          </Link>
        )}
      </Stack>
    </Container>
  );
};

export default Footer;
